
<template>
  <div class="taglist">
    <div v-if="loaded">
      <div class="taglist-item" v-for="(tag, index) in orderedTags()" v-bind:key="index" @click="selectTag(tag.id)" >
        {{tagTitle(tag.id)}} <div class="taglist-item-remove" v-on:click.stop @click="deleteTag(tag.id)"><svgicon icon="delete" width="24" height="24" color="#334274"></svgicon></div>
      </div>
      <div class="taglist-item --add" @click="addTag()" v-if="!addTagFlag">
        <div class="taglist-item-remove"><svgicon icon="add" width="24" height="24" color="#334274"></svgicon></div>
      </div>
      <div v-if="addTagFlag && tags" class="taglist-item-new">
        <vue-awesomplete @selectcomplete="addTagComplete()" v-if="addTagFlag" v-model="value" @keyup.enter.native="addTagNew()" :placeholder="'Hier suchen…'" :setting="{ autoFirst: true, list: this.tagsList , data: function (item, input) { return { label: item.title, value: item['.key'] } } }" ref="tagsplete"></vue-awesomplete>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import BlurEditable from '@/components/BlurEditable' // eslint-disable-line
import Taglist from '@/components/Taglist' // eslint-disable-line
import EditorFirepad from '@/components/EditorFirepad' // eslint-disable-line
import VueAwesomplete from 'vue-awesomplete' // eslint-disable-line
import AwesompleteCss from 'awesomplete/awesomplete.css' // eslint-disable-line
import moment from 'moment'
import _ from 'lodash'

var db = firebase.database()
var postTagsRef = db.ref('posts')
var tagsRef = db.ref('tags')

export default {
  name: 'Taglist',
  props: ['postKey'],
  components: {
    VueAwesomplete
  },
  data () {
    return {
      addTagFlag: false,
      value: null,
      loaded: false,
      custom: true
    }
  },
  methods: {
    orderedTags () {
      let dataPosts = _.orderBy(this.postData.tags, ['added'], ['asc'])
      return dataPosts
    },
    deleteTag (tag) {
      postTagsRef.child(this.postKey).child('tags').child(tag).remove()
    },
    tagTitle (tag) {
      if (tag) {
        if (this.tags[tag].title) {
          return this.tags[tag].title
        }
      }
    },
    selectTag (tag) {
      // console.log('taglink')
      this.$parent.$parent.setFilter({ tag: tag })
    },
    addTag () {
      this.addTagFlag = true
      this.$nextTick(() => {
        this.$refs.tagsplete.$el.focus()
      })
    },
    addTagNew () {
      this.$nextTick(() => {
        if (this.custom) {
          let self = this
          let myRef = tagsRef.push()
          let key = myRef.key
          let newData = {
            title: self.value
          }
          myRef.set(newData)
          postTagsRef.child(self.postKey).child('tags').child(key).child('id').set(key)
          postTagsRef.child(self.postKey).child('tags').child(key).child('added').set(moment().format())
          this.$refs.tagsplete.internalValue = null
          document.activeElement.blur()
          this.value = null
          this.$nextTick(() => {
            this.$refs.tagsplete.destroy()
            this.addTagFlag = false
          })
        }
      })
    },
    addTagComplete () {
      this.custom = false
      this.$nextTick(() => {
        postTagsRef.child(this.postKey).child('tags').child(this.value).child('id').set(this.value)
        postTagsRef.child(this.postKey).child('tags').child(this.value).child('added').set(moment().format())
        this.$refs.tagsplete.internalValue = null
        document.activeElement.blur()
        this.value = null
        this.$nextTick(() => {
          this.$refs.tagsplete.destroy()
          this.addTagFlag = false
          this.custum = true
        })
      })
    }
  },
  firebase () {
    return {
      tags: {
        source: tagsRef,
        asObject: true
      },
      tagsList: tagsRef,
      postData: {
        source: postTagsRef.child(this.postKey),
        asObject: true
      }
    }
  },
  mounted () {
    tagsRef.once('value', snapshot => {
      this.loaded = true
    })
  }
}
</script>

<style scoped lang="scss">

  .taglist {
    margin: 5px 0 5px;
  }
  .taglist-item {
    &:not(.--add) {
      user-select: none;
    }
    font-size: $font-size-small;
    display: inline-block;
    color: $color-action;
    background: rgba($color-action, 0.1);
    border-radius: 2px;
    line-height: 26px;
    padding: 0px 3px 0px 8px;
    margin-right: 5px;
    cursor: pointer;
    svg {
      margin-top: -2px;
    }
    &.--add {
      padding-left: 3px;
      background: transparent;
      border: 1px dashed rgba($color-action, 0.25);
      .taglist-item-remove {
        opacity: 1;
      }
    }
  }
  .taglist-item-remove {
    display: inline-block;
    color: $color-action;
    path {
      fill: $color-action;
    }
    opacity: 0.3;
  }

</style>



// WEBPACK FOOTER //
// src/components/Taglist.vue